import * as numeral from 'numeral';
import * as _ from 'underscore';

import { AfterViewInit, Component, ElementRef, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';

import { EmitterService } from '../../../../core/utility/services/emitter.service';
import { ColorPalette } from '../../../analytics-core/interfaces/partner.interface';
import { DownloadConfig } from '../../../analytics-core/interfaces/widget.interface';
import { ColorUtilityService } from '../../../analytics-core/services/color.utility.service';
import { EVENT_EMITTERS, PATHS } from '../../../analytics/constants/analytics.constants';
import { AnalyticsDataModel } from '../../../analytics/models/analytics.datamodel';
import { AnalyticsService } from '../../../analytics/services/analytics.service';
import { WidgetCore } from '../../interfaces/widget.core.interface';
import { DeviceTableComponent } from '../device-table/device-table.component';

@Component({
	selector: 'app-devicesr6',
	styleUrls: ['./devicesr6.component.css'],
	templateUrl: './devicesr6.component.html'
})
export class Devicesr6Component extends DeviceTableComponent implements OnInit, AfterViewInit, WidgetCore, OnDestroy {
	@Input() downloadconfig: string;
	@Input() legend: any;
	@Input() metricsarray: any;
	@Input() sectionclass: any;
	@Input() downloadcsvcolumns: any;
	@ViewChild('chartElement') chartElement: ElementRef;

	public sectiontitle: string;
	public key: string;
	public colors: string;
	public groupby: string;
	public showLoad = true;
	public hasData = true;
	public donutColors: string[] = [];
	public colorPalette: ColorPalette;
	public reloadSubscription;
	public widgetDataSubscription;
	public downloadConfiguration: DownloadConfig;
	public legendData: any;
	public chartDataObj = [];
	public donutArray = [];
	public currentLegend: any;
	public currentChartData: any;
	public totalsArray = [];
	public donutOptions = {};
	public metricsArray = [];
	public downloadCSVColumns: any;

	constructor(
		protected analyticsService: AnalyticsService,
		protected colorUtilityService: ColorUtilityService,
		protected analyticsDataModel: AnalyticsDataModel
	) {
		super(analyticsService, colorUtilityService, analyticsDataModel);
	}

	ngOnInit(): void {
		this.downloadConfiguration = JSON.parse(decodeURI(this.downloadconfig));
		this.downloadCSVColumns = JSON.parse(decodeURI(this.downloadcsvcolumns));
		this.legend = JSON.parse(decodeURI(this.legend));
		this.metricsArray = JSON.parse(decodeURI(this.metricsarray));
		if (this.metricsArray) {
			this.metricsArray = _.filter(this.metricsArray, (item) => {
				return this.analyticsDataModel.checkComponentForPermission(item);
			});
		}
		this.processLegendData();
		this.requestData();
	}

	ngAfterViewInit(): void {
		this.colorPalette = this.analyticsDataModel.partner.colorPalette;
		this.donutColors = this.colors.split(',');
	}

	processLegendData(): void {
		this.currentLegend = this.legend[0].displayName;
	}

	updateLegendData(legend: any): void {
		this.currentLegend = legend;
		this.currentChartData = this.chartDataObj[this.currentLegend];
	}

	requestData(): void {
		this.hasData = true;
		this.showLoad = true;
		this.widgetDataSubscription = this.analyticsService.processWidgetRequest(this.key).subscribe((response: any) => {
			this.showLoad = false;
			if (response.success) {
				this.hasData = true;
				this.legendData = _.pluck(response.data, 'device');
				this.processResponseData(response.data);
			} else {
				this.hasData = false;
			}
		});
	}

	processResponseData(responseData: any): void {
		if (responseData.length > 0 && responseData[0].cost) {
			// tslint:disable-next-line: number-literal-format
			let totalCost = 0.0;
			for (let i = 0; i < responseData.length; i++) {
				responseData[i].cost = parseFloat(responseData[i].cost).toFixed(2);
				if (i < responseData.length - 1) {
					totalCost += parseFloat(responseData[i].cost);
				} else {
					responseData[i].cost = (100 - totalCost).toFixed(2);
				}
			}
		}

		for (const metric of this.metricsArray) {
			if (metric) {
				const sum = responseData.reduce((s, f) => s + Number(f[metric.valueKey]), 0);
				this.totalsArray[metric.valueKey] = sum;
			}
		}
		_.each(responseData, (resp) => {
			this.donutArray = [];
			_.each(this.metricsArray, (obj, i) => {
				const yValue =
					(Math.round(Number(resp[this.metricsArray[i].valueKey])) / this.totalsArray[this.metricsArray[i].valueKey]) *
					100;
				const newObj = {
					series: [
						{
							data: [
								{
									color: this.colorPalette.primaryColor,
									innerRadius: '60%',
									radius: '100%',
									y: yValue
								}
							]
						}
					],
					title: this.getMetricName(this.metricsArray[i].title),
					value: this.metricsArray[i].isFloat
						? parseFloat(resp[this.metricsArray[i].valueKey]).toFixed(2).toLocaleString() + '%'
						: Number(resp[this.metricsArray[i].valueKey]).toLocaleString()
				};
				this.donutArray.push(newObj);
			});
			this.chartDataObj[resp['device']] = this.donutArray;
		});
		if (!this.legendData.includes(this.currentLegend)) {
			this.currentLegend = this.legendData[0];
		}
		this.currentChartData = this.chartDataObj[this.currentLegend];
		const chartData: any[] = [];
		const tableData: any[] = [];
		this.hasData = responseData.length > 0;
		for (let i = 0; i < responseData.length; i++) {
			const chartObj: any = {};
			chartObj.name = responseData[i].device;
			chartObj.color = this.colorUtilityService.getHEXByColorType(this.colorPalette, this.donutColors[i], 1);
			chartObj.y = responseData[i][this.groupby] * 1;
			chartData.push(chartObj);

			let impressions;
			let clickRate;
			let cost;
			let clicks;
			let householdVisits;
			let websiteAttributions;
			let view_throughs;
			let viewthroughrate;
			let youtube_verified_imprs;
			let youtube_verified_imprs_rate;
			let youtube_imprs;

			this.columns = [
				{
					cellClass: 'display-device',
					headerClass: 'display-deviceHeader',
					name: 'Devices',
					prop: 'device',
					resizeable: false
				}
			];

			if (responseData[i].impressions) {
				impressions = responseData[i].impressions;
				this.columns.push({
					cellClass: 'display-impressions',
					comparator: this.impressionsComparator.bind(this),
					headerClass: 'display-impressionsHeader',
					name: 'Impressions',
					prop: 'formatted_impressions',
					resizeable: false
				});
			}

			if (responseData[i].clicks) {
				clicks = responseData[i].clicks;
				this.columns.push({
					cellClass: 'display-clicks',
					comparator: this.clicksComparator.bind(this),
					headerClass: 'display-clicksHeader',
					name: 'Clicks',
					prop: 'formatted_clicks',
					resizeable: false
				});
			}

			if (responseData[i].clickthroughrate) {
				clickRate = responseData[i].clickthroughrate;
				this.columns.push({
					cellClass: 'display-clickRate',
					comparator: this.clickRateComparator.bind(this),
					headerClass: 'display-clickRateHeader',
					name: 'Click Rate',
					prop: 'formatted_click_rate',
					resizeable: false
				});
			}

			if (clickRate && clickRate != null) {
				clickRate = parseFloat(clickRate).toFixed(2);
			} else {
				clickRate = 0;
			}

			if (responseData[i].household_visits && this.analyticsDataModel.getCurrentPath() == PATHS.CTV) {
				householdVisits = responseData[i].household_visits;
				this.columns.push({
					cellClass: 'ctv-householdVisits',
					comparator: this.householdVisitsComparator.bind(this),
					headerClass: 'ctv-householdVisitsHeader',
					name: 'Household Site Visits',
					prop: 'formatted_household_visits',
					resizeable: false
				});
			}

			if (responseData[i].website_attributions && this.analyticsDataModel.getCurrentPath() == PATHS.RADIO) {
				websiteAttributions = responseData[i].website_attributions;
				this.columns.push({
					cellClass: 'ctv-websiteAttributions',
					comparator: this.websiteAttributionsComparator.bind(this),
					headerClass: 'ctv-websiteAttributionsHeader',
					name: 'Website Attributions',
					prop: 'formatted_website_attributions',
					resizeable: false
				});
			}

			if (responseData[i].cost && this.analyticsDataModel.getCurrentPath() !== PATHS.SOCIAL) {
				cost = responseData[i].cost;
				this.columns.push({
					cellClass: 'display-clickRate',
					comparator: this.costComparator.bind(this),
					headerClass: 'display-costHeader',
					name: 'Cost',
					prop: 'formatted_cost',
					resizeable: false
				});
				if (cost != null) {
					cost = parseFloat(cost).toFixed(2);
				} else {
					cost = 0;
				}
			}

			if (
				responseData[i].view_throughs &&
				this.analyticsDataModel.getCurrentPath() !== PATHS.SEM &&
				this.analyticsDataModel.getCurrentPath() !== PATHS.SOCIAL
			) {
				view_throughs = responseData[i].view_throughs;
				this.columns.push({
					cellClass: 'display-clicks',
					comparator: this.viewThroughComparator.bind(this),
					headerClass: 'display-clicksHeader',
					name: 'View Throughs',
					prop: 'formatted_view_throughs',
					resizeable: false
				});
			}

			if (
				responseData[i].viewthroughrate &&
				this.analyticsDataModel.getCurrentPath() !== PATHS.SEM &&
				this.analyticsDataModel.getCurrentPath() !== PATHS.SOCIAL
			) {
				viewthroughrate = responseData[i].viewthroughrate;
				this.columns.push({
					cellClass: 'display-clickRate',
					comparator: this.viewThroughRateComparator.bind(this),
					headerClass: 'display-clickRateHeader',
					name: 'View Through Rate',
					prop: 'formatted_viewthroughrate',
					resizeable: false
				});
				if (viewthroughrate != null) {
					viewthroughrate = parseFloat(viewthroughrate).toFixed(2);
				} else {
					viewthroughrate = 0;
				}
			}

			if (
				responseData[i].viewthroughrate &&
				this.analyticsDataModel.getCurrentPath() === PATHS.PREROLL &&
				this.metricsArray.some((el) => el.valueKey === 'youtube_verified_imprs')
			) {
				if (responseData[i].clicks) {
					youtube_verified_imprs = responseData[i].youtube_verified_imprs;
					youtube_imprs = responseData[i].youtube_imprs;
					this.columns.push({
						cellClass: 'display-clicks',
						comparator: this.youtubeImpressionsComparator.bind(this),
						headerClass: 'display-clicksHeader',
						name: 'Youtube Views',
						prop: 'formatted_youtube_verified_imprs',
						resizeable: false
					});
				}

				if (responseData[i].clickthroughrate) {
					youtube_verified_imprs_rate =
						responseData[i].youtube_verified_imprs_rate != null ? responseData[i].youtube_verified_imprs_rate : 0;
					this.columns.push({
						cellClass: 'display-clickRate',
						comparator: this.youtubeRateComparator.bind(this),
						headerClass: 'display-clickRateHeader',
						name: 'Youtube View Rate',
						prop: 'formatted_youtube_verified_imprs_rate',
						resizeable: false
					});
				}
			}

			const obj = {
				device: responseData[i].device,
				formatted_impressions: numeral(responseData[i].impressions).format('0,0'),
				impressions: parseInt(responseData[i].impressions, 10)
			};

			if (responseData[i].clicks) {
				obj['clicks'] = parseInt(clicks, 10);
				obj['formatted_clicks'] = numeral(clicks).format('0,0');
			}

			if (responseData[i].household_visits) {
				obj['formatted_household_visits'] = numeral(householdVisits).format('0,0');
				obj['household_visits'] = parseInt(householdVisits, 10);
			}

			if (responseData[i].website_attributions) {
				obj['formatted_website_attributions'] = numeral(websiteAttributions).format('0,0');
				obj['website_attributions'] = parseInt(websiteAttributions, 10);
			}

			if (responseData[i].clickthroughrate) {
				obj['click_rate'] = clickRate;
				obj['formatted_click_rate'] = parseFloat(clickRate).toFixed(2) + '%';
			}

			if (responseData[i].cost) {
				obj['cost'] = cost;
				obj['formatted_cost'] = cost + '%';
			}
			if (responseData[i].view_throughs && view_throughs !== undefined) {
				obj['view_throughs'] = parseInt(view_throughs, 10);
				obj['formatted_view_throughs'] = numeral(view_throughs).format('0,0');
			}
			if (responseData[i].viewthroughrate && viewthroughrate !== undefined) {
				obj['viewthroughrate'] = viewthroughrate;
				obj['formatted_viewthroughrate'] = parseFloat(viewthroughrate).toFixed(2) + '%';
			}
			if (responseData[i].youtube_verified_imprs && youtube_verified_imprs !== undefined) {
				obj['youtube_verified_imprs'] = parseInt(youtube_verified_imprs, 10);
				obj['formatted_youtube_verified_imprs'] = numeral(youtube_verified_imprs).format('0,0');
			}
			if (responseData[i].youtube_verified_imprs_rate && youtube_verified_imprs_rate !== undefined) {
				obj['youtube_verified_imprs_rate'] = youtube_verified_imprs_rate;
				obj['formatted_youtube_verified_imprs_rate'] = parseFloat(youtube_verified_imprs_rate).toFixed(2) + '%';
			} else if (responseData[i].youtube_verified_imprs_rate === null) {
				obj['youtube_verified_imprs_rate'] = youtube_verified_imprs_rate;
				obj['formatted_youtube_verified_imprs_rate'] = parseFloat(youtube_verified_imprs_rate).toFixed(2) + '%';
			}
			if (responseData[i].youtube_imprs && youtube_imprs !== undefined) {
				obj['youtube_imprs'] = parseInt(youtube_imprs, 10);
			}
			tableData.push(obj);
		}
		this.seriesData = chartData;
		this.tableData = tableData;
		this.addFooterToTableData();
	}

	getMetricName(text: string): string {
		return text.replace(/_|-/g, ' ');
	}

	downloadCSV(): void {
		this.analyticsService.downloadCSV(
			this.downloadConfiguration.csvQueryKey ? this.downloadConfiguration.csvQueryKey : this.key,
			this.downloadConfiguration.fileName,
			this.downloadCSVColumns
		);
	}

	ngOnDestroy(): void {
		if (this.reloadSubscription) {
			this.reloadSubscription.unsubscribe();
		}
		if (this.widgetDataSubscription) {
			this.widgetDataSubscription.unsubscribe();
		}
	}

	protected addFooterToTableData(): void {
		const impressionsSum = this.calculateSumFromArray(_.pluck(this.tableData, 'impressions'));
		this.totalObj = { impressions: impressionsSum };
		if (this.tableData && this.tableData.length > 0 && Object.keys(this.tableData[0]).includes('clicks')) {
			const clicksSum = this.calculateSumFromArray(_.pluck(this.tableData, 'clicks'));
			let clickRateSum = (clicksSum / impressionsSum) * 100;
			clickRateSum = parseFloat(clickRateSum.toFixed(2));
			if (clickRateSum === 100) {
				clickRateSum = 100;
			}
			clicksSum >= 0 ? (this.totalObj['displayClicks'] = true) : (this.totalObj['displayClicks'] = false);
			this.totalObj['clicks'] = clicksSum;
			clickRateSum >= 0 ? (this.totalObj['displayClickRate'] = true) : (this.totalObj['displayClickRate'] = false);
			this.totalObj['clickRate'] = clickRateSum;
		}
		if (this.tableData && this.tableData.length > 0 && Object.keys(this.tableData[0]).includes('household_visits')) {
			const householdVisitsSum = this.calculateSumFromArray(_.pluck(this.tableData, 'household_visits'));
			householdVisitsSum >= 0
				? (this.totalObj['ctvHouseholdVisits'] = true)
				: (this.totalObj['ctvHouseholdVisits'] = false);
			this.totalObj['householdVisits'] = householdVisitsSum;
		}
		if (
			this.tableData &&
			this.tableData.length > 0 &&
			Object.keys(this.tableData[0]).includes('website_attributions')
		) {
			const websiteAttributionsSum = this.calculateSumFromArray(_.pluck(this.tableData, 'website_attributions'));
			websiteAttributionsSum >= 0
				? (this.totalObj['ctvWebsiteAttributions'] = true)
				: (this.totalObj['ctvWebsiteAttributions'] = false);
			this.totalObj['websiteAttributions'] = websiteAttributionsSum;
		}
		if (this.tableData && this.tableData.length > 0 && Object.keys(this.tableData[0]).includes('cost')) {
			if (this.tableData[0].cost !== 0) {
				let costSum = this.calculateSumFromArray(_.pluck(this.tableData, 'cost')).toFixed(2);
				if (Number(costSum) >= 100) {
					costSum = '100';
				}
				costSum >= 0 ? (this.totalObj['displayCost'] = costSum) : (this.totalObj['displayCost'] = false);
				this.totalObj['cost'] = costSum;
			}
		}

		if (this.tableData && this.tableData.length > 0 && Object.keys(this.tableData[0]).includes('view_throughs')) {
			const viewSum = this.calculateSumFromArray(_.pluck(this.tableData, 'view_throughs'));
			let throughRateSum = (viewSum / impressionsSum) * 100;
			throughRateSum = parseFloat(throughRateSum.toFixed(2));
			if (throughRateSum === 100) {
				throughRateSum = 100;
			}
			viewSum >= 0 ? (this.totalObj['displayViewThroughs'] = true) : (this.totalObj['displayViewThroughs'] = false);
			this.totalObj['view_throughs'] = viewSum;
			throughRateSum >= 0
				? (this.totalObj['displayViewThroughRate'] = true)
				: (this.totalObj['displayViewThroughRate'] = false);
			this.totalObj['viewthroughrate'] = throughRateSum;
		}

		if (
			this.tableData &&
			this.tableData.length > 0 &&
			Object.keys(this.tableData[0]).includes('youtube_verified_imprs')
		) {
			const youtubeImprsSum = this.calculateSumFromArray(_.pluck(this.tableData, 'youtube_imprs'));
			const youtubeVerifiedImprsSum = this.calculateSumFromArray(_.pluck(this.tableData, 'youtube_verified_imprs'));
			let youtubeImprsRateSum = (youtubeVerifiedImprsSum / youtubeImprsSum) * 100;
			youtubeImprsRateSum = parseFloat(youtubeImprsRateSum.toFixed(2));
			if (youtubeImprsRateSum === 100) {
				youtubeImprsRateSum = 100;
			} else if (isNaN(youtubeImprsRateSum)) {
				youtubeImprsRateSum = 0.0;
			}
			youtubeVerifiedImprsSum >= 0
				? (this.totalObj['displayYoutubeImprs'] = true)
				: (this.totalObj['displayYoutubeImprs'] = false);
			this.totalObj['youtube_verified_imprs'] = youtubeVerifiedImprsSum;
			youtubeImprsRateSum >= 0
				? (this.totalObj['displayYoutubeImprsRate'] = true)
				: (this.totalObj['displayYoutubeImprsRate'] = false);
			this.totalObj['youtube_verified_imprs_rate'] = youtubeImprsRateSum;
		}
	}

	protected calculateSumFromArray(array: number[]): any {
		return _.reduce(
			array,
			(memo, num) => {
				return parseFloat(memo + '') + parseFloat(num + '');
			},
			0
		);
	}
}
